/**
 * @name FacetSearchBar.Entry.js
 *
 * @author Anchor Group : Brandon Doser <bdoser@anchorgroup.tech>
 * 
 * @since last updated date 2024-07-12
 * 
 * @file extension description
 */

define('FacetSearchBar.Entry',
	[
		'FacetSearchBar.View',
		'Facets.FacetedNavigationItem.View'
	],
	function (
		FacetSearchBarView,
		FacetsFacetedNavigationItemView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				const Layout = container.getComponent('Layout');
				let model = new Backbone.Model({});
				let facetId = '';

				_.extend(FacetsFacetedNavigationItemView.prototype, {
					//Wrap the getContext to modify the context return to the template tied to the View.
					getContext: _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function (fn) {
						let context = fn.apply(this, _.toArray(arguments).splice(1));
						facetId = context.facetId;

						let self = this;
						//Model event to get the searchbar text changes and see what options need to be hidden
						model.on('change:inputText', function (modelAttributes) {
							//If the facetId in the current context matches the facetId for the searchbar that was typed in
							if (modelAttributes.get('facetId') == context.facetId) {
								let labels = [];
								let inputText = modelAttributes.get('inputText').toLowerCase();
								if (inputText != '') {
									for (let i = 0; i < context.displayValues.length; i++) {
										//If an option does not start with the input text from the searchbar

										if (!((context.displayValues[i].label).toLowerCase().startsWith(inputText))) {
											//Set the hideLabels variable with an array of the options for the facet that need to be hidden
											labels.push(context.displayValues[i].label)
											self.hideLabels = labels;
										} else if (self.hideLabels != undefined) {
											if ((self.hideLabels).includes(context.displayValues[i].label)) {
												(self.hideLabels).splice(labels.indexOf(context.displayValues[i].label), 1);
											}
										}
									}
								} else {
									self.hideLabels = undefined;
								}
								//Set collapseOverride in order to keep the dropdown menu open when typing in searchbar
								self.collapseOverride = false;
								self.render();
							}

						});

						//Use the collapseOverride to determine whether to keep the dropdown for a facet open.
						if (this.collapseOverride == undefined) {
							this.collapseOverride = context.isCollapsed
						}

						for (let i = 0; i < context.displayValues.length; i++) {
							//If there are labels to hide then extend the context for those displayValues to set willDisplay to false in order to hide the option.
							if (this.hideLabels) {
								if (this.hideLabels.includes(context.displayValues[i].label)) {
									_.extend(context.displayValues[i], { willDisplay: false });
								} else {
									_.extend(context.displayValues[i], { willDisplay: true });
								}
							} else {
								_.extend(context.displayValues[i], { willDisplay: true });
							}
						}

						//Extend the context return to override the isCollapsed variable with own determination of when to keep dropdown collapsed.
						return _.extend(context, {
							isCollapsed: self.collapseOverride
						});
					})
				});

				if (Layout) {
					Layout.registerView('facet.searchbar', function () {
						return new FacetSearchBarView({ container: container, model: model, facetId: facetId });
					});
				}
			}
		};
	});
